export const MenuOptions = {
    MAIN: -1,
    AGENDATYPE: 0, 
    YEAR: 1,
    DATE: 2,
    AGENDAITEM: 3,
    DOCUMENT: 4,
    SEARCHRESULT: 5
}